import { __assign } from "tslib";
import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
export var withPresetIconProps = function (Component) { return function (props) {
    return React.createElement(Component, __assign({}, props, { size: IconSize.MEDIUM, disableDefaultColors: true }));
}; };
//# sourceMappingURL=withPresetIconProps.js.map